import React from "react";
import { useState } from "react";
import Calendar from "../Calendar";

function PropsFlow() {
    const [state, setState] = useState<any>({
        selectDateType: "single",
        templateClr: "green",
        disableDates: "",
        slotInfo: "1",
        showDatelabel: "0",
        showDateInputField: "1",
        showSelectMonthArrow: "0",
        showSelectYearArrow: "0",
        showArrow: "1",
    })
    const setStateFunc = (e: any) => {
        const {name, value} = e.target
        setState((prevState: any)=>({
            ...prevState,
            [name]:value
        }))
    }

    return(
        <div>
        <h4 id="propsFlow" className="singleHeader">Example: Props Flow</h4>
        <div className="propsFlow-flex">
        <div className="propFlowCal">
          <Calendar 
            selectDateType={state.selectDateType}
            templateClr={state.templateClr}
            disableDates={state.disableDates}
            slotInfo={state.slotInfo === "1" ? true :false}
            showDatelabel={state.showDatelabel === "1" ? true :false}
            showDateInputField={state.showDateInputField === "1" ? true :false}
            showSelectMonthArrow={state.showSelectMonthArrow === "1" ? true :false}
            showSelectYearArrow={state.showSelectYearArrow === "1" ? true :false}
            showArrow={state.showArrow === "1" ? true :false}
          />
        </div>
        <div className="propsSelect">
            <div>
                <label>selectDateType</label><br/>
                <select onChange={setStateFunc} name={"selectDateType"} value={state.selectDateType}>
                    <option value="single">single</option>
                    <option value="multiple">multiple</option>
                    <option value="range">range</option>
                </select>
            </div>

            <div>
                <label>templateClr</label><br/>
                <select onChange={setStateFunc} name={"templateClr"} value={state.templateClr}>
                    <option value="green">green</option>
                    <option value="blue">blue</option>
                </select>
            </div>

            <div>
                <label>disableDates</label><br/>
                <select onChange={setStateFunc} name={"disableDates"} value={state.disableDates}>
                    <option value="">Select</option>
                    <option value="past">past</option>
                    <option value="future">future</option>
                </select>
            </div>

            <div>
                <label>selectDateType</label><br/>
                <select onChange={setStateFunc} name={"selectDateType"} value={state.selectDateType}>
                    <option value="past">past</option>
                    <option value="future">future</option>
                </select>
            </div>

            <div>
                <label>slotInfo</label><br/>
                <select onChange={setStateFunc} name={"slotInfo"} value={state.slotInfo}>
                    <option value="1">true</option>
                    <option value="0">false</option>
                </select>
            </div>

            <div>
                <label>showDatelabel</label><br/>
                <select onChange={setStateFunc} name={"showDatelabel"} value={state.showDatelabel}>
                    <option value="0">false</option>
                    <option value="1">true</option>
                </select>
            </div>

            <div>
                <label>showDateInputField</label><br/>
                <select onChange={setStateFunc} name={"showDateInputField"} value={state.showDateInputField}>
                    <option value="1">true</option>
                    <option value="0">false</option>
                </select>
            </div>

            <div>
                <label>showSelectMonthArrow</label><br/>
                <select onChange={setStateFunc} name={"showSelectMonthArrow"} value={state.showSelectMonthArrow}>
                    <option value="0">false</option>
                    <option value="1">true</option>
                </select>
            </div>

            <div>
                <label>showSelectYearArrow</label><br/>
                <select onChange={setStateFunc} name={"showSelectYearArrow"} value={state.showSelectYearArrow}>
                    <option value="0">false</option>
                    <option value="1">true</option>
                </select>
            </div>

            <div>
                <label>showArrow</label><br/>
                <select onChange={setStateFunc} name={"showArrow"} value={state.showArrow}>
                    <option value="1">true</option>
                    <option value="0">false</option>
                </select>
            </div>
        </div>
        </div>
      </div>
    )
}

export default PropsFlow;